export const iState = {
    busquedaExpediente: {},
    consultarExpediente: {}
}

export const comercianteReducer = ( state = iState, action ) => {
    const { type, payload } = action;

    switch(type) {
        case 'add':
            return { ...state, ...payload };

        case 'clear':
            return iState;

        default :
            return state;
    }
}